<template>
  <div id="page-wrap" v-if="loggedIn">
    <PageHeader class="hidden-sm"></PageHeader>
    <div class="container content-wrap">
      <div class="row">
        <div>
          <ProfileContent :device="'mobile'" :nav="'profile'"></ProfileContent>
        </div>

        <MobileNav :activeLink="'profile'" class="visible-xs visible-sm"></MobileNav>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "./PageHeader/index";
import SettledTransactions from "./SettledTransactions/index";
import MobileNav from "./MobileNav/index";
import ProfileContent from "./ProfileContent/index";
import TransactionsDetail from "./TransactionsDetail/index";
import { mapGetters } from "vuex";

export default {
  name: "Settledtransaction",
  data() {
    return {
      page: undefined
    };
  },
  components: {
    PageHeader,
    SettledTransactions,
    ProfileContent,
    TransactionsDetail,
    MobileNav
  },
  computed: {
    ...mapGetters(["activeTransaction", "loggedIn"])
  },
  mounted() {
    this.page = this.$route.params.page;
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/sass/variables";

.content-section {
  min-height: 650px;
  background: #fff;
}
.content-wrap {
  padding: 0 15px;
  @media screen and (min-width: $md) {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProfileMobile.vue